import { createAsyncThunk } from '@reduxjs/toolkit';
import { refreshAndRetry } from '../utils/refreshAndRetry';
import { track } from '../../utils/analytics';

// The account's device list (Account → Devices). Plain thunks returning
// results to the caller; the list is small and screen-local, so it is not
// kept in Redux.

export const fetchSessions = createAsyncThunk(
    'sessions/fetch',
    async () => {
        const result = await refreshAndRetry((token) => window.electron.auth.listSessions(token));
        if (result?.error) throw new Error(typeof result.error === 'string' ? result.error : (result.error.message || 'Could not load devices'));
        track('devices_viewed', { count: (result.sessions || []).length });
        return { sessions: result.sessions || [], currentSessionId: result.currentSessionId || null };
    }
);

export const revokeSession = createAsyncThunk(
    'sessions/revoke',
    async ({ sessionId, current }) => {
        const result = await refreshAndRetry((token) => window.electron.auth.revokeSession(token, sessionId));
        if (result?.error) throw new Error(typeof result.error === 'string' ? result.error : (result.error.message || 'Could not sign that device out'));
        track('device_signed_out', { scope: current ? 'current' : 'one' });
        return result;
    }
);

export const revokeOtherSessions = createAsyncThunk(
    'sessions/revokeOthers',
    async () => {
        const result = await refreshAndRetry((token) => window.electron.auth.revokeOtherSessions(token));
        if (result?.error) throw new Error(typeof result.error === 'string' ? result.error : (result.error.message || 'Could not sign other devices out'));
        track('device_signed_out', { scope: 'others', count: result.revoked || 0 });
        return result;
    }
);
